import React from "react";
import PropTypes from "prop-types";
import SpotCheckbox from "./SpotCheckbox";
import CustomSelect from "./CustomSelect";

const SpotInput = props => {
  const { spot, handleChange, handleBlur, values } = props;
  const selectSize = [];
  const periodSize = [];
  let selectInitialVal = 0.7;
  let periodInitialVal = 5;
  for (let i = 0; i < 14; i += 1) {
    selectSize.push(Math.round(selectInitialVal * 10) / 10);
    selectInitialVal += 0.1;
    periodSize.push(Math.round(periodInitialVal));
    periodInitialVal += 1;
  }
  // console.log(selectSize, periodSize);

  return (
    <div>
      <SpotCheckbox
        spot={spot}
        handleChange={handleChange}
        handleBlur={handleBlur}
        values={values}
      />
      {values[spot] && (
        <>
          Alert when {"<= "}
          <CustomSelect
            aria-label="Select Size"
            name={`${spot}Size`}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values[`${spot}Size`]}
          >
            {selectSize.map(size => {
              return (
                <option
                  key={`${size}Size`}
                  value={size}
                  label={`${size.toFixed(1)} m`}
                />
              );
            })}
          </CustomSelect>{" "}
          @{" "}
          <CustomSelect
            aria-label="Select Period"
            name={`${spot}Period`}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values[`${spot}Period`]}
          >
            {periodSize.map(size => {
              return (
                <option
                  key={`${size}Seconds`}
                  value={size}
                  label={`${size} Sec`}
                />
              );
            })}
          </CustomSelect>
        </>
      )}
    </div>
  );
};

SpotInput.propTypes = {
  spot: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired
};

export default SpotInput;
